module.exports = __webpack_public_path__ + "media/images/field_12_2020-e5019d3d09086c5af273371f121678d4.png";